<template>
  <div class="fixed-check-list">
    <div class="fixed-check-list__title">チェックリスト</div>
    <ul class="fixed-check-list__wrap">
      <li
        class="fixed-check-list__node"
        :class="{ 'fixed-check-list__node--checked': jacket }">
        <span class="fixed-check-list__name">
          ジャケット画像
        </span>
        <span class="fixed-check-list__status">
          <span v-if="jacket">登録済</span>
          <span v-else>未登録</span>
        </span>
      </li>
      <li
        class="fixed-check-list__node"
        :class="{ 'fixed-check-list__node--checked': product }">
        <span class="fixed-check-list__name">
          リリース情報
        </span>
        <span class="fixed-check-list__status">
          <span v-if="product">登録済</span>
          <span v-else>未登録</span>
        </span>
      </li>
      <li
        class="fixed-check-list__node"
        :class="{ 'fixed-check-list__node--checked': track }">
        <span class="fixed-check-list__name">
          楽曲情報
        </span>
        <span class="fixed-check-list__status">
          <span v-if="track">登録済</span>
          <span v-else>未登録</span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ReleaseCheckList',
  props: {
    tracks: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      jacket: false,
      product: false,
      track: false,
    }
  },
  watch: {
    tracks() {
      this.updateList()
    },
  },
  mounted() {
    this.updateList()
  },
  methods: {
    updateList() {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      this.jacket = release.jacketImage && release.jacketImage.length > 0
      this.product = release.product && release.product.is_draft < 2
      this.track = this.trackEnabled(release)
    },
    trackEnabled(release) {
      let total = 0
      let missingFile = false
      let missingTrackInfo = false
      release.discs.forEach((disc) => {
        total += disc.tracks.length
        // すべての楽曲に楽曲ファイルがセットされている
        disc.tracks.forEach(track => {
          if (!track.filename) {
            missingFile = true
          }
          if (!track.title_kana
            || track.copyright_artists.length === 0
            || !track.copyright_artists[0].name_ja) {
            missingTrackInfo = true
          }
        })
      })
      // アルバムは2曲以上必要
      if (release.type === 'album' && total < 2) {
        return false
      }

      return total > 0 && !missingFile && !missingTrackInfo
    },
  },
}
</script>
